import React, { Component } from "react";
import SingleService from "./SingleService";
const services = [
  {
    title: "Accessibility",
    description: "Our System provides Universal Access to disabled persons",
    icon: "fa-universal-access",
  },
  {
    title: "Responsive Design",
    description:
      "Responsiveness makes it easy to open in Mobiles, laptops, or PCs efficiently",
    icon: "fa-laptop",
  },
  {
    title: "Security",
    description:
      "Security Services to Ensure Total Protection against fraud and Corruption",
    icon: "fa-lock",
  },
];
class Services extends Component {
  render() {
    return (
      <section className="page-section" id="services">
        <div className="container">
          <div className="text-center">
            <h2 className="section-heading text-uppercase">Services</h2>
            <h3 className="section-subheading text-muted">
              Some Highlights from System Specifications
            </h3>
          </div>
          <div className="row text-center">
            {services.map((service, index) => {
              return <SingleService key={index} {...service} />; // ...is a spread operator
            })}
          </div>
        </div>
      </section>
    );
  }
}
export default Services;
